import { Copy, Danger, ImportCurve, Printer } from 'iconsax-reactjs'
import { BodyText, Button, HeadingText, Modal, ModalBody, ModalFooter, ModalHeader } from '../../../shared/ui'
import { XIcon } from 'lucide-react'

interface BackupModalProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  backupCodes: string[]
  handleCopy: () => void
  handleDownload: () => void
  handlePrint: () => void
  showCloseIcon: boolean
}

const BackupCodeModal = ({ isOpen, onOpenChange, backupCodes, handleCopy, handleDownload, handlePrint, showCloseIcon }: BackupModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onOpenChange} contentClassName='max-w-[560px] w-full'>
      <div className="bg-white">
        <ModalHeader className="flex flex-col gap-2">
          <div className="flex items-center gap-2 justify-between w-full">
          <HeadingText className="text-3xl font-semibold leading-tight text-[#161827]">
            Save your backup codes
          </HeadingText>
            {showCloseIcon && <XIcon onClick={() => onOpenChange(false)} className="cursor-pointer" />}
          </div>
          <BodyText className="text-[#383B56] leading-5 tracking-[-0.03em] text-sm font-[350]">
            If you lose access to your authenticator app, you can use the recovering codes <br /> below to get back into your Tradevu admin account
          </BodyText>
        </ModalHeader>
        <ModalBody className="space-y-4">
          <div className='rounded-[8px] bg-[#F7F9FC] p-4 self-stretch flex flex-wrap items-center justify-start gap-4'>
            {backupCodes?.map((code, index) => (
              <p key={index} className="w-[144px] tracking-[-0.025em] font-[450] leading-5 text-[#161827]">{code}</p>
            ))}
          </div>
          <div className="flex items-center gap-2">
            <Button onClick={handleCopy} size="md" className="h-10 rounded-[8px] flex items-center gap-2 justify-center border border-[#F2F3FC] shadow-sm" variant='outline'><Copy variant='Bold' size="18" /> Copy</Button>
            <Button onClick={handleDownload} size="md" className="h-10 rounded-[8px] flex items-center gap-2 justify-center border border-[#F2F3FC] shadow-sm" variant='outline'><ImportCurve variant='Bold' size="18" /> Download</Button>
            <Button onClick={handlePrint} size="md" className="h-10 rounded-[8px] flex items-center gap-2 justify-center border border-[#F2F3FC] shadow-sm" variant='outline'><Printer variant='Bold' size="18" /> Print</Button>
          </div>
          <div>
            <p className="flex items-start justify-start gap-2 text-[#383B56] leading-5 tracking-[-0.03em] text-sm font-[350]"><Danger variant='Bold' size="20" /> Keep these codes safe and don’t share them. They can only be used once, and you won’t see them again for security reasons.</p>
          </div>

        </ModalBody>
      </div>
      <ModalFooter className="border flex flex-col justify-start p-5 border-t-[#F2F3FC] bg-[#FBFCFE]">
        <p className='italic text-[#383B56] text-left text-sm font-[350] w-full'>You can only close this modal after downloading or copying the codes</p>
        <div className="flex justify-end items-center w-full">
          <Button onClick={() => onOpenChange(false)} size="md" className="h-10 ml-auto rounded-[8px] flex items-center gap-2 justify-center">Done</Button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default BackupCodeModal